(()=>{
  'use strict';
  const dialog=document.getElementById('fdnav');
  const configNode=document.getElementById('fdnav-config');
  if(!dialog||!configNode||typeof dialog.showModal!=='function'||window.FDNavigationV4)return;
  let config;
  try{config=JSON.parse(configNode.textContent)}catch{return}
  const root=config.root||'/';
  const mobile=matchMedia('(max-width:989px)');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const scroller=dialog.querySelector('.fdnav-scroll');
  const title=dialog.querySelector('#fdnav-title');
  const heading=title.querySelector('[data-fdnav-heading]');
  const back=dialog.querySelector('[data-fdnav-back]');
  const closeButton=dialog.querySelector('[data-fdnav-close]');
  const message=dialog.querySelector('[data-fdnav-message]');
  const selector='#header-component .header__drawer summary, #header-component .header__icon--menu';
  const titles={home:'Menu',clothing:'Autres vêtements',club:'FootDrop Club',help:'Aide & contact'};
  let panel='home',opener=null,homeScroll=0,homeFocus=null,savedY=0,styles=null;
  let offerTask=null,lastOffer=0,closing=null;
  const originalTriggers=new Map();

  function destination(path){
    let url;
    try{url=new URL(path,location.origin)}catch{return null}
    if(url.origin!==location.origin||!/^https?:$/.test(url.protocol))return null;
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    return url.href;
  }
  function prepareLinks(){
    dialog.querySelectorAll('a[href]').forEach(a=>{
      const url=destination(a.getAttribute('href'));
      if(url)a.href=url;
    });
  }
  function focus(el){
    if(!el?.isConnected)return;
    try{el.focus({preventScroll:true})}catch{el.focus()}
  }
  function nativeClose(){
    const old=document.getElementById('Details-menu-drawer-container');
    if(old){old.removeAttribute('open');old.classList.remove('menu-open')}
  }
  function markTriggers(open){
    document.querySelectorAll(selector).forEach(el=>{
      const keys=['aria-controls','aria-haspopup','aria-expanded'];
      if(!originalTriggers.has(el))originalTriggers.set(el,keys.map(key=>[key,el.getAttribute(key)]));
      if(!mobile.matches){
        for(const [key,value] of originalTriggers.get(el)){
          if(value===null)el.removeAttribute(key);else el.setAttribute(key,value);
        }
        return;
      }
      el.setAttribute('aria-controls','fdnav');
      el.setAttribute('aria-haspopup','dialog');
      el.setAttribute('aria-expanded',String(open));
    });
  }
  function showPanel(key,restore=false){
    if(!titles[key])return;
    if(panel==='home'&&key!=='home'){homeScroll=scroller.scrollTop;homeFocus=document.activeElement}
    panel=key;
    dialog.dataset.panel=key;
    dialog.querySelectorAll('[data-fdnav-panel]').forEach(el=>{el.hidden=el.dataset.fdnavPanel!==key});
    heading.textContent=titles[key];
    back.hidden=key==='home';
    message.textContent='';
    scroller.scrollTop=key==='home'&&restore?homeScroll:0;
    if(dialog.open)focus(key==='home'&&restore?homeFocus:title);
  }
  function lock(){
    savedY=scrollY;
    styles={};
    for(const key of ['position','top','left','right','width']){
      styles[key]=[document.body.style.getPropertyValue(key),document.body.style.getPropertyPriority(key)];
    }
    document.body.style.setProperty('position','fixed');
    document.body.style.setProperty('top',-savedY+'px');
    document.body.style.setProperty('left','0');
    document.body.style.setProperty('right','0');
    document.body.style.setProperty('width','100%');
    document.documentElement.classList.add('fdnav-lock');
  }
  function unlock(){
    if(!styles)return;
    for(const [key,[value,priority]] of Object.entries(styles)){
      if(value)document.body.style.setProperty(key,value,priority);
      else document.body.style.removeProperty(key);
    }
    styles=null;
    document.documentElement.classList.remove('fdnav-lock');
    window.scrollTo({top:savedY,left:0,behavior:'auto'});
  }
  function finishClose(){
    dialog.classList.remove('fdnav-closing');
    if(dialog.open)dialog.close();
    unlock();
    markTriggers(false);
    nativeClose();
    focus(opener);
    closing=null;
  }
  function close(immediate=false){
    if(closing)return closing;
    if(!dialog.open){unlock();markTriggers(false);return Promise.resolve()}
    if(immediate||reduced.matches){finishClose();return Promise.resolve()}
    dialog.classList.add('fdnav-closing');
    closing=new Promise(resolve=>setTimeout(()=>{finishClose();resolve()},165));
    return closing;
  }
  function open(trigger){
    if(!mobile.matches||dialog.open||closing)return;
    opener=trigger||document.querySelector(selector);
    nativeClose();
    if(document.getElementById('fd-search-studio')?.open)window.FDSearchStudio?.close?.();
    document.querySelectorAll('dialog[open]').forEach(el=>{if(el!==dialog)el.close()});
    showPanel('home');
    prepareLinks();
    lock();
    try{
      dialog.showModal();
      markTriggers(true);
      focus(closeButton);
      refreshOffer();
    }catch{
      unlock();
      document.documentElement.classList.remove('fdnav-ready');
      const fallback=destination(root+'pages/explorer');
      if(fallback)location.assign(fallback);
    }
  }
  async function request(url){
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),6500);
    try{
      const response=await fetch(url,{credentials:'same-origin',cache:'no-cache',signal:controller.signal});
      if(!response.ok)throw Error('HTTP '+response.status);
      return await response.text();
    }finally{clearTimeout(timer)}
  }
  function paintOffer(state){
    if(!state||!Number.isFinite(state.quantity)||!Number.isFinite(state.discount))return;
    const q=Math.max(0,state.quantity),rest=q%3;
    let heading='2 achetés = 1 offert';
    let copy='Sur les maillots et ensembles éligibles.';
    let href=root+'collections/tout-le-catalogue?fdf=maillot-individuel,ensemble-maillot&fdtypes=1';
    if(state.memberOfferApplied&&state.discount>0){
      heading='Ton avantage membre est appliqué';
      copy='Retrouve tes remises dans le panier.';
      href=config.cart;
    }else if(state.returning){
      heading='Tes avantages FootDrop';
      copy='Consulte ton offre dans le panier.';
      href=config.cart;
    }else if(rest===2){
      heading='Choisis ton 3e maillot offert';
      copy='Ajoute-le pour compléter ton offre.';
    }else if(rest===1){
      copy='Ajoute un 2e maillot, puis choisis le 3e offert.';
    }else if(q>0&&state.discount>0){
      heading='Ta remise est prise en compte';
      copy='Vérifie le détail dans ton panier.';
      href=config.cart;
    }else if(q>0){
      heading='Tes maillots sont dans le panier';
      copy='Vérifie que la remise est appliquée.';
      href=config.cart;
    }
    dialog.querySelector('[data-fdnav-offer-title]').textContent=heading;
    dialog.querySelector('[data-fdnav-offer-copy]').textContent=copy;
    dialog.querySelector('[data-fdnav-offer]').href=destination(href);
  }
  function refreshOffer(){
    if(offerTask||Date.now()-lastOffer<2000)return offerTask;
    const url=new URL(destination(root));
    url.searchParams.set('section_id','fd-nav-status');
    url.searchParams.set('_fdnav',String(Date.now()));
    offerTask=request(url.href).then(html=>{
      const doc=new DOMParser().parseFromString(html,'text/html');
      const node=doc.querySelector('[data-fdnav-state]');
      if(!node)throw Error('state');
      paintOffer(JSON.parse(node.textContent));
      lastOffer=Date.now();
    }).catch(()=>{
      dialog.querySelector('[data-fdnav-offer-title]').textContent='Les offres FootDrop';
      dialog.querySelector('[data-fdnav-offer-copy]').textContent='Consulte les remises dans ton panier.';
      dialog.querySelector('[data-fdnav-offer]').href=destination(config.cart);
    }).finally(()=>{offerTask=null});
    return offerTask;
  }
  async function copyCode(){
    const node=dialog.querySelector('[data-fdnav-code]');
    const code=node?.textContent.trim();
    if(!code)return;
    try{
      await navigator.clipboard.writeText(code);
      message.textContent='Code copié.';
    }catch{
      const range=document.createRange(),selection=window.getSelection();
      range.selectNodeContents(node);
      selection.removeAllRanges();
      selection.addRange(range);
      message.textContent='Sélectionne puis copie ce code avec ton téléphone.';
    }
  }
  async function shareCode(){
    const code=dialog.querySelector('[data-fdnav-code]')?.textContent.trim();
    if(!code)return;
    if(!navigator.share){await copyCode();return}
    try{
      await navigator.share({title:'FootDrop',text:'Découvre FootDrop et utilise mon code de parrainage '+code+' lors de ta commande.',url:location.origin+root});
    }catch(error){
      if(error.name!=='AbortError')message.textContent='Le partage n’a pas fonctionné. Tu peux copier ton code.';
    }
  }
  function syncIdentity(){
    const identity=[window.FD_LOYALTY,window.__FD_ACCOUNT_IDENTITY].find(v=>v&&(v.customerId||v.email));
    if(!identity)return;
    const account=dialog.querySelector('[data-fdnav-account]');
    account.href=destination(root+'pages/membre');
    account.querySelector('span').textContent='Mon espace membre';
  }
  async function handle(event){
    const trigger=event.target.closest?.(selector);
    if(trigger&&mobile.matches){
      event.preventDefault();
      event.stopImmediatePropagation();
      open(trigger);
      return;
    }
    if(!dialog.open||!dialog.contains(event.target))return;
    const el=event.target.closest('a,button');
    if(!el)return;
    if(event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(closing){event.preventDefault();return}
    if(el.hasAttribute('data-fdnav-open')){
      event.preventDefault();
      event.stopImmediatePropagation();
      showPanel(el.dataset.fdnavOpen);
      return;
    }
    if(el.hasAttribute('data-fdnav-close')){event.preventDefault();close();return}
    if(el.hasAttribute('data-fdnav-back')){event.preventDefault();showPanel('home',true);return}
    if(el.hasAttribute('data-fdnav-copy')){event.preventDefault();copyCode();return}
    if(el.hasAttribute('data-fdnav-share')){event.preventDefault();shareCode();return}
    if(el.hasAttribute('data-fdnav-search')||el.hasAttribute('data-fdnav-photo')){
      event.preventDefault();
      event.stopImmediatePropagation();
      const photo=el.hasAttribute('data-fdnav-photo'),fallback=el.href;
      await close();
      const api=window.FDSearchStudio;
      if(photo&&api?.openPhoto){
        Promise.resolve(api.openPhoto(opener)).catch(()=>location.assign(fallback));
      }else if(!photo&&api?.open){
        api.open();
      }else location.assign(fallback);
      return;
    }
    if(el.matches('a[href]')){
      const url=destination(el.getAttribute('href'));
      if(!url)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      await close();
      location.assign(url);
    }
  }
  window.addEventListener('click',handle,true);
  dialog.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const items=[...dialog.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex]')]
      .filter(el=>!el.disabled&&el.tabIndex>=0&&el.getClientRects().length);
    if(!items.length){event.preventDefault();focus(title);return}
    const first=items[0],last=items[items.length-1];
    if(event.shiftKey&&(document.activeElement===first||!items.includes(document.activeElement))){
      event.preventDefault();focus(last);
    }else if(!event.shiftKey&&document.activeElement===last){
      event.preventDefault();focus(first);
    }
  });
  dialog.addEventListener('cancel',event=>{
    event.preventDefault();
    if(panel!=='home')showPanel('home',true);
    else close();
  });
  dialog.addEventListener('close',()=>{
    if(!dialog.open){unlock();markTriggers(false);focus(opener)}
  });
  let outside=false;
  dialog.addEventListener('pointerdown',event=>{
    const rect=dialog.getBoundingClientRect();
    outside=event.target===dialog&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom);
  });
  dialog.addEventListener('click',event=>{
    if(outside&&event.target===dialog)close();
    outside=false;
  });
  mobile.addEventListener('change',()=>{if(!mobile.matches)close(true)});
  window.addEventListener('pagehide',()=>{if(dialog.open)close(true)});
  for(const name of ['fd:cart-added','cart:refresh','cart:updated']){
    document.addEventListener(name,()=>{lastOffer=0;if(dialog.open)refreshOffer()});
  }
  for(const name of ['fd:loyalty-ready','fd:account-identity'])document.addEventListener(name,syncIdentity);
  try{paintOffer(JSON.parse(dialog.querySelector('[data-fdnav-state]').textContent))}catch{}
  prepareLinks();
  syncIdentity();
  markTriggers(false);
  document.documentElement.classList.add('fdnav-ready');
  window.FDNavigationV4={open,close,version:'20260924-v4'};
})();
